<template>
  <CommonSettingsEditor
    :settings="currentSettings"
    save-button-text="Zapisz"
    @save="saveOrdersSettings"
  />
</template>
<script>

import CommonSettingsEditor from "@/components/widgets/CommonSettingsEditor.vue";
import {useOrdersManagerModule} from "@/state/pinia/ordersManagerModule";
import {useCommonAppModule, useLazyLoaderModule} from "@/state/pinia";

export default {
  name: "OrdersManagerSettingsList",
  props: {},
  components: {
    CommonSettingsEditor,
  },
  data() {
    return {
      currentSettings: [],
      
    };
  },
  computed: {
    commonModule(){
      return useCommonAppModule();
    },
    lazyloaderModule(){
      return useLazyLoaderModule();
    },
    ordersModule(){
      return useOrdersManagerModule();
    },
  },
  watch: {
    currentSettings: {
      handler(newVal, oldVal) {
        if (newVal != oldVal) {
          this.currentSettings.sort((item1, item2) => {
            return item1.position - item2.position;
          });
        }
      },
      deep: true,
    },
  },
  methods: {
    saveOrdersSettings(payload) {
      this.lazyloaderModule.setDisplayLazyLoader(true);
      this.lazyloaderModule.setProgressBarMessage("Zapis ustawień...");

      this.commonModule.saveSettings(payload);
      this.refreshSettingsList();
    },
    refreshSettingsList() {
      this.ordersModule.setOrdersManagerSettings([]);
      var requestPayload = {};
      this.ordersModule.httpGetOrdersManagerSettings(requestPayload).then(() => {
        this.currentSettings = JSON.parse(JSON.stringify(this.ordersModule.getOrdersManagerSettings));
      });
    },
  },

  created() {
    this.refreshSettingsList();
  },
};
</script>

<style scoped>
</style>
